import React, { useState } from "react";
import { TableDateRange } from "../../common/components/TableDateRange";
import { NoRecords } from "../../common/components/NoRecords";
import { LinkPosition } from "../../positions/Routes";
import { useQueryWithPagination } from "../../utils/Hooks";
import { AxiosEmployeePositionAPI } from "../../common/Api";
import { Loader } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import { PaginationButtons } from "../../common/components/PaginationButtons";

const EmployeePositionTable = ({ records, ordering, setOrdering }) => {
  if (records.length === 0) {
    return (
      <NoRecords
        message={"Não existem cargos cadastrados para este funcionário!"}
      />
    );
  }

  const rows = records.map((el) => ({
    id: el.id,
    name: <LinkPosition position={el.position} />,
    seniorityLevel: el.position.seniority_level?.level,
    startDate: el.timespan.lower,
    endDate: el.timespan.upper,
    reviewAccess: el.review_access,
  }));

  return (
    <TableDateRange
      recordName={"Cargo"}
      data={rows}
      reviewAccess={true}
      ordering={ordering}
      setOrdering={setOrdering}
      nameColumn="position"
      seniorityLevel={true}
    />
  );
};

export const EmployeePositionList = ({ employee_id }) => {
  const [ordering, setOrdering] = useState(null);

  const { isPending, data, error, handlePrevious, handleNext } =
    useQueryWithPagination({
      queryKey: ["employee-position-list", employee_id, ordering],
      queryFn: AxiosEmployeePositionAPI.getForEmployee,
      employee_id: employee_id,
      ordering: ordering,
    });

  if (isPending) return <Loader active />;
  if (error) return <ErrorSegment message={error.message} />;
  if (data) {
    return (
      <>
        <EmployeePositionTable
          records={data.results}
          ordering={ordering}
          setOrdering={setOrdering}
        />
        <PaginationButtons
          previous={data?.previous}
          next={data?.next}
          onPrevious={handlePrevious}
          onNext={handleNext}
        />
      </>
    );
  }

  return null;
};
